export const CREATE_EMAIL_AUTOMATION = 'CREATE_EMAIL_AUTOMATION'
export const UPDATE_EMAIL_AUTOMATION = 'UPDATE_EMAIL_AUTOMATION'
export const DELETE_EMAIL_AUTOMATION = 'DELETE_EMAIL_AUTOMATION'
